export interface Role {
  value: string,
  text: string,
  description: string,
  hidden?: boolean,
  organismes?: boolean,
  delegations?: boolean
}

export const roles: Role[] = [
  { value: 'ROLE_USER', text: 'Utilisateur', description: '', hidden: true },
  { value: 'ROLE_PECHEUR', text: 'Pêcheur', description: '' },
  { value: 'ROLE_OPERATEUR_SAISIE', text: 'Opérateur de saisie', description: '', delegations: true },
  { value: 'ROLE_GESTIONNAIRE', text: 'Gestionnaire de peuplement', description: '', organismes: true },
  { value: 'ROLE_ADMIN_TECH_REGION', text: 'Gestionnaire d\'activité', description: '', organismes: true },
  { value: 'ROLE_ADMIN_NATIONAL', text: 'Administrateur national', description: '' },
  { value: 'ROLE_MINISTERE', text: 'Ministère', description: '' },
  { value: 'ROLE_AGENT_CONTROLE', text: 'Agent de contrôle', description: '' },
  { value: 'ROLE_ADMIN', text: 'Administrateur', description: '' }
]

export default { roles }
